import ManagementTemplate from '../../templates/management/management'

const Management = () => {
    return (
        <ManagementTemplate />
    )
}

export default Management